/* Shared by the legacy shell and React. Never replace the browser's storage
 * getters: a user denying persistence still gets a usable, tab-local session. */
(function (root, factory) {
    var storage = root.TempStarsBrowserStorage || factory(root);
    root.TempStarsBrowserStorage = storage;
    if (typeof module === 'object' && module.exports) module.exports = storage;
})(typeof window !== 'undefined' ? window : {}, function (root) {
    function createStorage(name) {
        var memory = Object.create(null);
        var unavailable = false;
        function nativeStorage() {
            try { return root[name] || null; }
            catch (_) { unavailable = true; return null; }
        }
        function run(method, args) {
            // Keep the fallback authoritative for this page after a failure,
            // but always attempt logout cleanup. A quota error can prevent a
            // write while native removeItem/clear still work.
            if (unavailable && method !== 'removeItem' && method !== 'clear') return { ok: false };
            var native = nativeStorage();
            if (native) {
                try { return { ok: true, value: native[method].apply(native, args) }; }
                catch (_) { unavailable = true; }
            }
            return { ok: false };
        }
        return {
            getItem: function (key) {
                key = String(key);
                var result = run('getItem', [key]);
                if (result.ok) {
                    if (result.value === null) delete memory[key];
                    else memory[key] = result.value;
                    return result.value;
                }
                return Object.prototype.hasOwnProperty.call(memory, key) ? memory[key] : null;
            },
            setItem: function (key, value) {
                key = String(key); value = String(value);
                memory[key] = value;
                run('setItem', [key, value]);
            },
            removeItem: function (key) {
                key = String(key);
                delete memory[key];
                run('removeItem', [key]);
            },
            clear: function () { memory = Object.create(null); run('clear', []); },
            key: function (index) {
                var result = run('key', [index]);
                return result.ok ? result.value : Object.keys(memory)[index] || null;
            },
            get length() {
                var native = unavailable ? null : nativeStorage();
                try { if (native) return native.length; } catch (_) { unavailable = true; }
                return Object.keys(memory).length;
            },
            isPersistentAvailable: function () {
                var probe = '__ts_storage_probe__';
                var result = run('setItem', [probe, probe]);
                if (result.ok) run('removeItem', [probe]);
                return result.ok;
            }
        };
    }
    return { localStorage: createStorage('localStorage'), sessionStorage: createStorage('sessionStorage') };
});
